import {
  Form,
  FormControlProps,
  SelectPicker,
  SelectPickerProps,
} from "rsuite";
import { useAppSelector, useAppDispatch } from "../../../core/redux/reduxStore";
import { ActionUI } from "../../../core/redux/slices/sliceUI";

type SelectPickerFormInputProps = {
  name?: string;
  label?: string;
  showError?: boolean;
  errorText?: string;
  isCleanable?: boolean;
} & FormControlProps &
  SelectPickerProps<any>;

export const SelectPickerFormInput = ({
  name,
  label,
  placement,
  isCleanable,
  showError,
  errorText,
  ...props
}: SelectPickerFormInputProps) => {
  const { userFormError } = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();
  const errorStyles = (errorVisible: any) => {
    return {
      display: errorVisible ? "block" : "none",
      color: "red",
      marginTop: 6,
    };
  };

  return (
    <Form.Group controlId={name} className="m-0 p-0 w-100">
      {/* {label && <Form.ControlLabel>{label}</Form.ControlLabel>} */}
      <Form.Control
        accepter={SelectPicker}
        name={name}
        label={label}
        defaultvalue={name}
        placement={placement}
        onSelect={() => {
          dispatch(
            ActionUI.setUserFormError({
              ...userFormError,
              [name]: props.value,
            })
          );
        }}
        cleanable={isCleanable ?? true}
        errorMessage={showError ? errorText : null}
        {...props}
      />
      {/* {props.showError && props.errorText ? (
        <Form.ErrorMessage show={true} placement={"bottomStart"}>
          {props.errorText}
        </Form.ErrorMessage>
      ) : (
        <></>
      )} */}
      {showError && errorText ? (
        <div style={errorStyles((userFormError as any)[name])}>
          {errorText}
        </div>
      ) : (
        <></>
      )}
    </Form.Group>
  );
};
